import { useMemo } from 'react';

export function PlayerAvatar({
  name,
  url,
  size = 32,
  ring,
  dim,
  online,
}: {
  name: string;
  url?: string;
  size?: number;
  ring?: boolean;
  dim?: boolean;
  /** Show a green status dot at bottom-right when truthy. */
  online?: boolean;
}) {
  const initials = useMemo(
    () =>
      name
        .split(/\s+/)
        .map((s) => s[0]?.toUpperCase())
        .filter(Boolean)
        .slice(0, 2)
        .join(''),
    [name],
  );
  const px = `${size}px`;
  const ringClass = ring
    ? 'ring-2 ring-accent ring-offset-2 ring-offset-bg'
    : 'ring-1 ring-border-strong/60';
  const dimClass = dim ? 'opacity-50 grayscale' : '';
  const dotSize = Math.max(8, Math.round(size * 0.28));
  const dotBorder = Math.max(1.5, Math.round(size * 0.06));

  const inner = url ? (
    <img
      src={url}
      alt={name}
      width={size}
      height={size}
      className={`rounded-full bg-panel-2 object-cover ${ringClass} ${dimClass}`}
      style={{ width: px, height: px }}
    />
  ) : (
    <div
      className={`grid place-items-center rounded-full bg-panel-2 font-semibold text-fg ${ringClass} ${dimClass}`}
      style={{ width: px, height: px, fontSize: size * 0.4 }}
    >
      {initials || '?'}
    </div>
  );

  if (online === undefined) return inner;

  return (
    <span className="relative inline-block" style={{ width: px, height: px }}>
      {inner}
      <span
        className={`absolute bottom-0 right-0 block rounded-full ${
          online ? 'bg-success' : 'bg-muted-2'
        }`}
        style={{
          width: dotSize,
          height: dotSize,
          border: `${dotBorder}px solid var(--color-bg)`,
        }}
        aria-hidden
      />
    </span>
  );
}
